export const AUTH_ACCESS_TOKEN_KEY = 'auth.access_token'

export const shouldExpireAdminSession = ({
  status,
  authorization,
  apiToken,
  storedToken,
  alreadyHandled,
}) =>
  status === 401
  && alreadyHandled !== true
  && Boolean(authorization || apiToken || storedToken)

export const adminListLoadError = (status, section) =>
  status === 401
    ? ''
    : `Не удалось загрузить ${section}. Проверьте соединение и повторите.`
